// src/data/ResourcesData.js

const MEDIA_BASE_URL = "https://media.satoshiadvance.com/images/Resources/";

export const ResourceData = [
    {
      title: "Wallets & Exchanges",
      image: `${MEDIA_BASE_URL}/WalletsandExchanges.png`,
      items: [
        {
          title: "Gemini Exchange",
          url: "https://www.gemini.com",
          description: "Gemini is a regulated cryptocurrency exchange and custodian founded by Cameron and Tyler Winklevoss that allows users to buy, sell, and securely store over 70 cryptocurrencies through its trusted platform featuring strong security controls and compliance measures.",
          dateAdded: "March 2025"
        },
        {
          title: "Crypto.com",
          url: "https://www.crypto.com",
          description: "Crypto.com is a comprehensive cryptocurrency platform serving over 140 million users worldwide with trading services for more than 200 digital assets, along with an integrated ecosystem that includes a mobile app, exchange, Visa card, DeFi wallet, and staking options.",
          dateAdded: "March 2025"
        },
        {
          title: "Coinbase",
          url: "https://www.coinbase.com",
          description: "Coinbase is the largest U.S.-based cryptocurrency exchange serving over 108 million customers worldwide, offering a user-friendly platform for buying, selling, and managing hundreds of digital assets with advanced trading tools, cold storage security, and educational resources for both retail and institutional investors.",
          dateAdded: "March 2025"
        },
        {
          title: "Binance",
          url: "https://www.binance.com",
          description: "Binance is the world's largest cryptocurrency exchange by trading volume, serving over 169 million users in more than 180 countries with access to trading 350+ cryptocurrencies, along with additional services including staking, NFTs, and earning platforms, though it has faced regulatory challenges in multiple jurisdictions.",
          dateAdded: "March 2025"
        },
        {
          title: "MetaMask",
          url: "https://metamask.io",
          description: "MetaMask is a non-custodial cryptocurrency wallet used by over 100 million users worldwide that enables interaction with Ethereum-based decentralized applications through browser extensions and mobile apps, providing secure storage and management of digital assets while primarily supporting Ethereum and EVM-compatible networks.",
          dateAdded: "March 2025"
        }
      ]
    },
    {
        title: "Popular Apps",
        image: `${MEDIA_BASE_URL}/KillerApps.png`,
        items: [
          {
            title: "Uniswap",
            url: "https://uniswap.org",
            description:
              "Uniswap is a widely-used decentralized exchange protocol on Ethereum that enables anyone to seamlessly swap ERC-20 tokens, provide liquidity for yield, and participate in DeFi without relying on centralized intermediaries.",
            dateAdded: "March 2025"
          },
          {
            title: "Rarible",
            url: "https://rarible.com",
            description:
              "Rarible is a community-focused NFT marketplace empowering creators, collectors, and enthusiasts to easily mint, buy, sell, and trade unique digital collectibles while fostering an open ecosystem for next-generation digital assets.",
            dateAdded: "March 2025"
          },
          {
            title: "Star Atlas",
            url: "https://staratlas.com",
            description:
              "Star Atlas is an immersive metaverse gaming platform set in a futuristic space-themed universe, leveraging blockchain technology to offer players true ownership of in-game items, strategic exploration, and a robust player-driven economy.",
            dateAdded: "March 2025"
          },
          {
            title: "dYdX",
            url: "https://dydx.exchange",
            description:
              "dYdX is a high-performance decentralized trading exchange that delivers margin, spot, and perpetual trading features for advanced crypto enthusiasts, all executed via smart contracts to enhance security and eliminate middlemen.",
            dateAdded: "March 2025"
          },
          {
            title: "DexTools",
            url: "https://www.dextools.io",
            description:
              "DexTools is a powerful analytics platform offering real-time charts, pair explorers, and advanced trading insights for decentralized exchanges, enabling users to track liquidity, monitor token performance, and make data-driven decisions in the evolving DeFi landscape.",
            dateAdded: "March 2025"
          }
        ]
      },
      {
        title: "Learning",
        image: `${MEDIA_BASE_URL}/LearningResources.png`,
        items: [
          {
            title: "Defi Lending",
            url: "https://youtu.be/pp9Abjlz7K4?si=RPuLzquvV-dG6va1",
            description: "This in-depth video explains the evolution of decentralized finance lending protocols, how users earn yield through trustless smart contracts, and why DeFi is reshaping the broader financial landscape.",
            dateAdded: "March 2025"
          },
          {
            title: "Binance Academy",
            url: "https://academy.binance.com",
            description: "Binance Academy is a comprehensive crypto education hub offering articles, videos, and interactive lessons that cover trading strategies, blockchain fundamentals, and cutting-edge developments in digital assets.",
            dateAdded: "March 2025"
          },
          {
            title: "Investopedia",
            url: "https://www.investopedia.com/cryptocurrency-4427699",
            description: "Investopedia’s cryptocurrency section provides approachable guides and in-depth tutorials on blockchain, digital currencies, and DeFi, helping both beginners and experienced investors expand their financial literacy.",
            dateAdded: "March 2025"
          },
          {
            title: "Bitcoin Whitepaper",
            url: "https://bitcoin.org/bitcoin.pdf",
            description: "Originally authored by Satoshi Nakamoto, this groundbreaking document outlines Bitcoin’s peer-to-peer electronic cash system and laid the foundation for modern blockchain technology.",
            dateAdded: "March 2025"
          },
          {
            title: "Buy Bitcoin",
            url: "https://www.fidelity.com/crypto",
            description: "Fidelity’s crypto platform delivers a regulated, user-friendly environment for purchasing and securing Bitcoin, complete with educational resources and portfolio management tools.",
            dateAdded: "March 2025"
          }
        ]
      }
      
  ];